import Button from '@mui/material/Button';
import AttendanceNameImg from './AttendanceNameImg';
import { useDispatch } from 'react-redux';
import { revertVerifyAttendance, verifyAttendance } from '../../../redux/features/attendanceSlice';

export const START_PORTION_TABLE_HEAD = [
  {
    field: 'name',
    flex: 1,
    minWidth: 300,
    headerName: 'Name',
    type: 'string',
    headerAlign: 'left',
    align: 'left',
    renderCell: (params) => AttendanceNameImg(params),
  },
  {
    field: 'department',
    flex: 1,
    minWidth: 200,
    headerName: 'departments',
    type: 'string',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'joinedDate',
    flex: 1,
    minWidth: 150,
    headerName: 'Join Date',
    type: 'string',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'exitDate',
    flex: 1,
    minWidth: 150,
    headerName: 'Exit Date',
    type: 'string',
    headerAlign: 'left',
    align: 'left',
  },
];

export const END_PORTION_TABLE_HEAD = ({ setRefresh, apiHandleHelper, dispatch }) => {
  return [
    {
      field: 'totalP',
      minWidth: 100,
      headerName: 'Total Present',
      type: 'string',
    },
    {
      field: 'totalWO',
      minWidth: 100,
      headerName: 'Total WO',
      type: 'string',
    },
    {
      field: 'totalHD',
      minWidth: 100,
      headerName: 'Total HD',
      type: 'string',
    },
    // {
    //   field: 'totalHF',
    //   minWidth: 100,
    //   headerName: 'Total HF',
    //   type: 'string',
    // },
    {
      field: 'totalA',
      minWidth: 100,
      headerName: 'Total A',
      type: 'string',
    },
    {
      field: 'totalLWP',
      minWidth: 100,
      headerName: 'Total LOP',
      type: 'string',
    },
    {
      field: 'totalCO',
      minWidth: 100,
      headerName: 'Total CO',
      type: 'string',
    },
    {
      field: 'totalDot',
      minWidth: 100,
      headerName: 'Total DL',
      type: 'string',
    },
    {
      field: 'totalEL',
      minWidth: 100,
      headerName: 'Total EL',
      type: 'string',
    },
    {
      field: 'totalPrivilegeLeave',
      minWidth: 150,
      headerName: 'Total Privilege Leave',
      type: 'string',
    },
    {
      field: 'totalCL',
      minWidth: 100,
      headerName: 'Total CL',
      type: 'string',
    },
    {
      field: 'totalSL',
      minWidth: 100,
      headerName: 'Total SL',
      type: 'string',
    },
    {
      field: 'totalPL',
      minWidth: 100,
      headerName: 'Total PL',
      type: 'string',
    },
    {
      field: 'totalML',
      minWidth: 100,
      headerName: 'Total ML',
      type: 'string',
    },
    {
      field: 'payableDays',
      minWidth: 150,
      headerName: 'Total Payable Days',
      type: 'string',
    },
    {
      field: 'verified_by_id',
      minWidth: 150,
      headerName: 'Verified By',
      valueGetter: ({ value, row }) => {
        return (value ? (value === row?.userId ? 'SELF' : 'HR') : 'N/A')
      },
    },
    {
      field: 'verified_timestamp',
      minWidth: 150,
      headerName: 'Verification',
      renderCell: ({ value, row }) => (
        <Button
          variant="outlined"
          disabled={Boolean(value)}
          color={!Boolean(row?.attendance_Id) ? 'error' : 'primary'}
          onClick={() => {
            dispatch(
              verifyAttendance({
                attendance_id: row?.attendance_Id,
              }),
            ).then((res) => apiHandleHelper(res, { onSuccess: () => setRefresh((prev) => !prev) }));
          }}
        >
          verify
        </Button>
      ),
    },
    {
      field: 'revert',
      minWidth: 150,
      headerName: 'Revert Verification',
      renderCell: ({ row }) => (
        <Button
          variant="outlined"
          disabled={!Boolean(row?.verified_timestamp)}
          color={'secondary'}
          onClick={() => {
            dispatch(
              revertVerifyAttendance({
                attendance_id: row?.attendance_Id,
              }),
            ).then((res) => apiHandleHelper(res, { onSuccess: () => setRefresh((prev) => !prev) }));
          }}
        >
          Revert
        </Button>
      ),
    },
    // {
    //     field: "Action",
    //     minWidth: 150,
    //     headerName: "Actions",
    //     type: "string",
    //     renderCell: (params) => AttendanceAction(params),
    // },
  ];
};
